// extracted by mini-css-extract-plugin
module.exports = {"facebook":"SocialButton_facebook__0ZFlG","template--login":"SocialButton_template--login__mYTTi","rotation":"SocialButton_rotation__Y4Xit"};